import Guid from "_shared/guids/guid";
import DocumentTopic from "documents/topics/document-topic";

export default class DocumentFromAPIRequest {
  public formData: FormData;

  constructor(file: File, name?: string | null, topics?: DocumentTopic[], templateIds?: Guid[]) {
    this.formData = new FormData();
    this.formData.append('File', file);
    if (name) {
      this.formData.append('FileName', name);
    }
    if (topics) {
      for (const topic of topics) {
        this.formData.append('Topics', JSON.stringify(topic.toJSON()));
      }
    }
    if (templateIds) {
      for (const templateId of templateIds) {
        this.formData.append('TemplateIds', templateId.value);
      }
    }
  }
}
